(() => {
  const STORAGE_KEY = 'ai_recent_breadcrumb_visit';

  const escapeHtml = (value) => String(value ?? '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');

  const readVisit = () => {
    try {
      const raw = window.sessionStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      const parsed = JSON.parse(raw);
      if (!parsed || typeof parsed !== 'object') return null;
      if (!parsed.title || !parsed.url || !parsed.type) return null;
      return parsed;
    } catch (error) {
      return null;
    }
  };

  const saveVisit = (visit) => {
    try {
      window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify({
        ...visit,
        timestamp: Date.now(),
      }));
    } catch (error) {
      // Ignore storage failures.
    }
  };

  const trackCurrentPage = () => {
    const tracked = document.querySelector('[data-breadcrumb-current="true"][data-breadcrumb-page][data-breadcrumb-title][data-breadcrumb-url]');
    if (tracked) {
      const type = tracked.dataset.breadcrumbPage;
      if (type === 'product' || type === 'collection') {
        saveVisit({
          type,
          title: tracked.dataset.breadcrumbTitle,
          url: tracked.dataset.breadcrumbUrl,
        });
      }
      return;
    }

    const productInfo = document.querySelector('product-info[data-url]');
    if (productInfo) {
      const title = document.querySelector('.product__title h1, .product__title h2, h1')?.textContent?.trim();
      if (title) {
        saveVisit({
          type: 'product',
          title,
          url: productInfo.dataset.url,
        });
      }
      return;
    }

    const collectionTitle = document.querySelector('.collection-hero__title')?.textContent?.trim();
    if (collectionTitle && document.body.classList.contains('template-collection')) {
      saveVisit({
        type: 'collection',
        title: collectionTitle,
        url: window.location.pathname,
      });
    }
  };

  const renderCartBreadcrumb = () => {
    const placeholder = document.querySelector('[data-cart-breadcrumb-previous]');
    const cartItem = document.querySelector('[data-cart-breadcrumb-current]');
    if (!placeholder || !cartItem) return;

    const visit = readVisit() || {
      type: 'collection',
      title: placeholder.dataset.fallbackTitle || 'All Products',
      url: placeholder.dataset.fallbackUrl || '/collections/all',
    };

    if (!visit.title || !visit.url) return;

    const separator = cartItem.closest('.ai-breadcrumbs-nav')
      ?.querySelector('.ai-breadcrumbs-separator')
      ?.textContent?.trim() || '/';

    placeholder.hidden = false;
    placeholder.innerHTML = `
      <a href="${escapeHtml(visit.url)}" class="ai-breadcrumbs-link"><span class="hover-underline">${escapeHtml(visit.title)}</span></a>
      <span class="ai-breadcrumbs-separator" aria-hidden="true">${escapeHtml(separator)}</span>
    `;
  };

  const init = () => {
    trackCurrentPage();
    renderCartBreadcrumb();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
